import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { trackDownloadClick } from '../services/analytics';

export default function CTA() {
  const ref = useScrollAnimation();

  return (
    <section ref={ref} className="fade-in bg-[#5B3FA6] py-16">
      <div className="mx-auto w-full max-w-4xl px-4 text-center md:px-8">
        <h2 className="font-[Nunito] text-3xl font-extrabold text-white md:text-4xl">
          Ready to make potty training less stressful?
        </h2>
        <p className="mt-4 text-lg text-white/80">Join 10,000+ families who train smarter, not harder.</p>
        <a
          href="#playstore"
          onClick={() => trackDownloadClick('final_cta')}
          className="mt-8 inline-block rounded-full bg-[#FF7B5B] px-8 py-3 font-semibold text-white shadow-lg transition hover:-translate-y-0.5"
        >
          Download Free on Android
        </a>
        <p className="mt-4 text-sm text-white/80">No credit card. No commitment. Free forever plan.</p>
      </div>
    </section>
  );
}

